import {observer} from 'mobx-react-lite'
import React, {CSSProperties} from 'react'
import tw from 'tailwind-styled-components'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {CutoffData} from '@components/timeline-new/types'
import {cn} from '@containers/html-utils'

const TwCutoffs = tw.div`
  h-24
  isolate
  overflow-hidden
  relative
  flex
  items-center
`

const TwCutoff = tw.div<{$border?: boolean; $center?: boolean}>`
  absolute
  flex
  items-center

  text-xs-regular
  text-secondary
  ${p => cn(p.$border && 'shadow-border-l-1 shadow-line-base')}
  ${p => cn(p.$center ? 'justify-center' : 'justify-start')}
`

export interface CutoffsProps {
  className?: string
  cutoffs: CutoffData[]
  type: 'top' | 'bottom'
}

export const Cutoffs = observer((props: CutoffsProps) => {
  const {className, cutoffs} = props
  const [state, store] = useTimelineNewStore()
  const isBottom = props.type === 'bottom'

  let width: undefined | string
  const shouldBeCenter =
    isBottom && (state.scale === 'days' || state.scale === 'years')

  return (
    <TwCutoffs className={className}>
      {cutoffs.map((x, index, arr) => {
        const pos = store.timeToPosition(x.timestamp)
        const style: CSSProperties = {
          transform: `translate(${pos}px,0px)`
        }

        if (shouldBeCenter) {
          if (width === undefined && index + 1 < arr.length) {
            const nextPos = store.timeToPosition(arr[index + 1].timestamp)
            width = `${nextPos - pos}px`
          }
          style.width = width
        }

        return (
          <TwCutoff
            key={x.timestamp}
            style={style}
            $border={x.border}
            $center={props.type === 'bottom'}
            className={cn(!shouldBeCenter && 'pl-8')}
          >
            {x.title}
          </TwCutoff>
        )
      })}
    </TwCutoffs>
  )
})
